module.exports = __webpack_public_path__ + "static/media/gun-safes-electronic-lock-ex.b03cbf8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/gun-safes-electronic-lock-ex.png
// module id = 1290
// module chunks = 0